import { Route, Routes } from "react-router";
import MyProfileView from "./MyProfileView";

export const MyProfile = () => {
  return (
    <Routes>
      <Route index element={<MyProfileView />} />
    </Routes>

  );
};
